import React from "react";
import "./AboutSection.css";
import { Link } from "react-router-dom";
function AboutSection() {
  return (
    <section className="about">
      
      {/* LEFT IMAGE */}
      <div className="about-image">
        <img src="/warehouse.jpg" alt="warehouse" />
      </div>

      {/* RIGHT CONTENT */}
      <div className="about-content">
        <h2>Welcome to Relyonneuk</h2>

        <p>
          From our global network, we supply premium paper and board products
          in reels and sheets to businesses worldwide, ensuring consistent
          quality and reliability.
        </p>

        <p>
          Our strong logistics and supply chain partnerships allow us to deliver
          efficiently across international markets, building long-term trust with
          our clients.
        </p>

        <h3>A Worldwide Local Company</h3>

        <p>
          With a presence across multiple countries, our experienced team is
          always ready to support your requirements and provide tailored
          solutions wherever you operate.
        </p>

        <div className="about-buttons">
   
          <Link to="/who-we-are" className="btn-primary">
            Who We Are →
          </Link>

          <Link to="/what-we-do" className="btn-outline">
            What We Do →
          </Link>

        </div>
      </div>

    </section>
  );
}

export default AboutSection;